/**
 * Helpers para normalizar la respuesta del endpoint /Quote/All.
 *
 * Forma antigua: array directo `[ {...}, {...} ]`.
 * Forma nueva:   objeto `{ data: [ ... ], pagingInfo: { page, limit, totalItems } }`.
 *
 * Los consumidores deben pasar `responseAllQuote` por estos helpers en lugar
 * de acceder directamente, para soportar ambas shapes sin reventar.
 */
export var getQuoteList = function (response) {
    if (Array.isArray(response))
        return response;
    if (response && Array.isArray(response.data))
        return response.data;
    return [];
};
export var getQuotePagingInfo = function (response) {
    var _a;
    if (!response || Array.isArray(response))
        return null;
    return (_a = response.pagingInfo) !== null && _a !== void 0 ? _a : null;
};
